import { CountryChangeStatusRequest } from './status';

export enum WebsocketEventType {
  UserCountryStatusChanged = 9,
}

export interface WebsocketEvent<T> {
  response: T;
  eventType: WebsocketEventType;
}

export interface CountryChangeStatusRequestEvent {
  countryRequest: CountryChangeStatusRequest;
}
